/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

/**
 * CKEditor link内のlink to my code(関連リンク)のセレクトボックスのデータ
 * （internlink pluginとvueK間のグローバル変数）
 */
window.InternPagesSelectBox = new Array();

//window.Vue = require('vue').default;

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

//Vue.component('example-component', require('./components/ExampleComponent.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

 import Vue from 'vue'
 import VueI18n from 'vue-i18n';   
 import VueRouter from 'vue-router'
 
 import 'chart.js/auto';
 import 'chartjs-adapter-moment'

const UserRegisterComponent = () => import("./components/UserRegister.vue");
const VuetifyMain = () => import("./VuetifyMain.vue");
const contactForm = () => import("./components/common/contact/contactForm.vue");
const customlanguagelist = () => import("./components/common/customlanguagelist/languageList.vue");
const userGuide = () => import("./components/common/UserGuide.vue");
const userGuideMobile = () => import("./components/common/UserGuideMobile.vue");
 // add
 //import 'bootstrap/dist/css/bootstrap.css'
 //import 'bootstrap-vue/dist/bootstrap-vue.css'
 Vue.config.productionTip = true
 import '@mdi/font/css/materialdesignicons.css' 

 import Toasted from 'vue-toasted'

 // moment Start===================
 //import moment from 'moment-timezone'
 //moment.tz.setDefault('Asia/Jakarta')
 //
 // Vuetify Start===================
 import Vuetify from './plugins/vuetify'
 //import 'vuetify/dist/vuetify.min.css';

 // vuerouter Start===================
 Vue.use(VueRouter)
 import router  from './router.js'

// vue i8n Start=======================
// 言語ファイルマージ
const merge = require("deepmerge");
const messageData = merge.all([
  require('../lang/common.json'), 
  require('../lang/languages.json'), 
]);

Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: 'en',
  messages:messageData,
})
// vue i8n End=======================

// vuex Start=====================
import store  from "./store.js";
// vuex End=======================

import { VueReCaptcha } from 'vue-recaptcha-v3';
Vue.use(VueReCaptcha, {
  siteKey: '6LejEYQeAAAAAB6Zz7bTsFYmkzOOqKYYkRKCUYQ4',
  loaderOptions: {
    autoHideBadge: true
  }
})

Vue.use(Toasted);

//import CKEditor from 'ckeditor4-vue'
//Vue.use(CKEditor);

import VueMeta from 'vue-meta'
Vue.use(VueMeta)

const app = new Vue({
    el: '#app',
    store,
    router,
    i18n,
    vuetify: Vuetify,
    components: {
        'user-register' : UserRegisterComponent,
        'main-component'  : VuetifyMain,
        'contact-form' : contactForm,
        'user-guide' : userGuide,
        'user-guide-mobile': userGuideMobile,
        'customlanguagelist' :customlanguagelist
    },
    metaInfo: {
      title: 'Login',
      titleTemplate: '%s | ' + process.env.MIX_APP_NAME
    }        
});

//Vue.prototype.$moment = moment;
